export const categories = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-apps-line' },
  { id: 'romance', name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { id: 'action', name: '动作', slug: 'action', icon: 'ri-sword-line' },
  { id: 'comedy', name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { id: 'suspense', name: '悬疑', slug: 'suspense', icon: 'ri-search-eye-line' },
  { id: 'drama', name: '剧情', slug: 'drama', icon: 'ri-film-line' },
];

export const tags = [
  '热血', '校园', '都市', '古风', '穿越', '重生', '逆袭',
  '治愈', '虐恋', '纯爱', '后宫', '养成', '系统', '复仇',
];

export const faqs = [
  {
    question: '虫虫漫画网是什么？',
    answer: '虫虫漫画网是一个专注于韩国漫画免费在线阅读的平台。我们提供海量的韩漫资源，支持下拉式阅读模式，让读者可以流畅地享受漫画内容，无需翻页打断阅读节奏。所有漫画均为正版授权或合法转载，确保读者能够安全、放心地阅读。',
  },
  {
    question: '虫虫漫画网的漫画是否需要付费？',
    answer: '虫虫漫画网上的大部分漫画均为免费阅读。我们通过广告收入维持平台运营，读者无需支付任何费用即可畅享海量韩漫资源。部分最新热门漫画可能会有短暂的付费抢先看机制，但最终都会转为免费。',
  },
  {
    question: '如何使用下拉式阅读功能？',
    answer: '下拉式阅读是虫虫漫画网的核心特色功能。您只需在漫画详情页点击任意章节，即可进入下拉式阅读模式。使用鼠标滚轮或手指滑动向下滚动，漫画内容会自动连续加载，无需点击翻页按钮，带来如行云流水般的阅读体验。',
  },
  {
    question: '虫虫漫画网支持哪些设备？',
    answer: '虫虫漫画网采用响应式设计，完美适配电脑、平板和手机等各类设备。无论您使用 Windows、Mac、iOS 还是 Android 系统，都能获得一致且优质的阅读体验。下拉式阅读在移动端的触屏滑动体验尤为出色。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '虫虫漫画网的漫画更新频率因作品而异。热门连载漫画通常每周更新 1-2 话，部分高人气作品可能会有更快的更新频率。我们会在漫画详情页标注最新的更新时间，您也可以关注喜欢的漫画以获取更新通知。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过多种方式在虫虫漫画网找到心仪的漫画：使用顶部的搜索框输入漫画名称或作者；通过分类页面按类型（恋爱、奇幻、动作等）浏览；查看首页的排行榜和推荐列表发现热门作品。我们还提供标签筛选功能，帮助您精准定位感兴趣的题材。',
  },
];